/**
 * Global shared state.
 */
import { make } from "vuex-pathify";

const notification = function(msg, icon, type) {
  return {
    message: msg,
    icon: icon,
    type: type,
    horizontalAlign: "center",
    verticalAlign: "top"
  };
};

// Convenience: global random GUID generator.
const uuidv4 = function() {
  // eslint-disable-next-line
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
};

// Convenience: global random shared secret generator.
const generateSharedSecret = function() {
  return uuidv4().replace(/-/g, "") + uuidv4().replace(/-/g, "");
};

// Convenience: global function to generate Sql-esque timestamp strings for querying historic data.
const generateSqlLikeTimestamp = function(daysPast) {
  const now = new Date(new Date().setDate(new Date().getDate() - daysPast));
  var year = "" + now.getUTCFullYear();
  var month = "" + (now.getUTCMonth() + 1);
  if (month.length == 1) {
    month = "0" + month;
  }
  var day = "" + now.getUTCDate();
  if (day.length == 1) {
    day = "0" + day;
  }
  var hour = "" + now.getUTCHours();
  if (hour.length == 1) {
    hour = "0" + hour;
  }
  var minute = "" + now.getUTCMinutes();
  if (minute.length == 1) {
    minute = "0" + minute;
  }
  var second = "" + now.getUTCSeconds();
  if (second.length == 1) {
    second = "0" + second;
  }
  return `${year}-${month}-${day} ${hour}:${minute}:${second} UTC`;
}

const state = {
  debug: process.env.NODE_ENV !== "production",
  notifications: [],
  guidGenerator: uuidv4,
  sharedSecretGenerator: generateSharedSecret,
  sqlTimestampGenerator: generateSqlLikeTimestamp
};

// automatically generate getters
const getters = make.getters(state);

const mutations = {
  ...make.mutations(state),

  pushInfo(state, msg) {
    state.notifications.push(notification(msg, "info", "info"));
  },
  pushSuccess(state, msg) {
    state.notifications.push(notification(msg, "check_circle", "success"));
  },
  pushAlert(state, msg) {
    state.notifications.push(notification(msg, "warning", "warning"));
  },
  pushError(state, msg) {
    state.notifications.push(notification(msg, "error", "danger"));
  },
  deleteNotification(state, i) {
    state.notifications.splice(i);
  }
};

const actions = {
  ...make.actions(state),
  popNotification({ commit }) {
    return new Promise(resolve => {
      if (!state.notifications || !state.notifications.length) {
        resolve();
      }
      var lastNotification =
        state.notifications[state.notifications.length - 1];
      commit("deleteNotification", state.notifications.length - 1);
      resolve(lastNotification);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
